import { render, staticRenderFns } from "./MaintenanceRequestsFilters.vue?vue&type=template&id=6064912c&"
import script from "./MaintenanceRequestsFilters.vue?vue&type=script&lang=js&"
export * from "./MaintenanceRequestsFilters.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceRequestsFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports